import Vue from 'vue'
import Vuex from 'vuex'
import api from '../api'

Vue.use(Vuex)

// 从localStorage加载登录状态（仅用于页面刷新时保持登录状态）
const loadLoginState = () => {
  try {
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'
    const currentUserStr = localStorage.getItem('currentUser')
    let currentUser = null
    if (currentUserStr) {
      currentUser = JSON.parse(currentUserStr)
    }
    return { isLoggedIn, currentUser }
  } catch (e) {
    console.error('加载登录状态失败', e)
    return { isLoggedIn: false, currentUser: null }
  }
}

const { isLoggedIn, currentUser } = loadLoginState()

// 从localStorage加载sessionToken
const loadSessionToken = () => {
  try {
    return localStorage.getItem('sessionToken') || null
  } catch (e) {
    console.error('加载sessionToken失败', e)
    return null
  }
}

export default new Vuex.Store({
  state: {
    // 用户管理（现在从API获取，不再存储在store中）
    isLoggedIn,
    currentUser,
    sessionToken: loadSessionToken(), // Session Token
    // 原有状态
    count: 1,
    selectedArea: 'A',
    selectedProvince: '京',
    zimuNum: 1,
    specialNum: 1,
    letterRules: [],
    currentRule: {
      positions: ['', '', '', '', ''],
      probability: 20,
      type: 'oil'
    },
    areaSettings: {
      areas: ['A'],
      areaProbabilities: {}
    },
    userName: null,
    carBrand: null,
    fixedPlate: null,
    recordPlates: []
  },
  mutations: {
    // 用户管理相关（用户数据现在通过API管理，这里只保留登录状态）
    setIsLoggedIn (state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn
      localStorage.setItem('isLoggedIn', isLoggedIn.toString())
    },
    setCurrentUser (state, user) {
      state.currentUser = user
      if (user) {
        localStorage.setItem('currentUser', JSON.stringify(user))
      } else {
        localStorage.removeItem('currentUser')
      }
    },
    setSessionToken (state, token) {
      state.sessionToken = token
      if (token) {
        localStorage.setItem('sessionToken', token)
      } else {
        localStorage.removeItem('sessionToken')
      }
    },
    // 原有mutations
    updateLetterRule (state, { positions, probability, type }) {
      state.currentRule = {
        positions: [...positions],
        probability,
        type
      }
    },
    addLetterRule (state) {
      state.letterRules.push({ ...state.currentRule })
    },
    removeLetterRule (state, index) {
      state.letterRules.splice(index, 1)
    },
    clearLetterRules (state) {
      state.letterRules = []
    },
    updateAreaSettings (state, { areas, areaProbabilities }) {
      state.areaSettings = {
        areas: [...areas],
        areaProbabilities: { ...areaProbabilities }
      }
    },
    updateUserName (state, userName) {
      state.userName = userName
    },
    updateCarBrand (state, carBrand) {
      state.carBrand = carBrand
    },
    updateFixedPlate (state, fixedPlate) {
      state.fixedPlate = fixedPlate
    }
  },
  actions: {
    // 异步获取用户列表
    async fetchUsers ({ commit }) {
      try {
        const response = await api.getUsers()
        if (response.success) {
          commit('setUsers', response.data)
        }
      } catch (error) {
        console.error('获取用户列表失败:', error)
        throw error
      }
    },
    // 异步添加用户
    async addUser ({ commit, dispatch }, userData) {
      try {
        const response = await api.addUser(userData)
        if (response.success) {
          // 重新获取用户列表
          await dispatch('fetchUsers')
          return response
        }
      } catch (error) {
        console.error('添加用户失败:', error)
        throw error
      }
    },
    // 异步更新用户
    async updateUser ({ commit, dispatch }, { id, userData }) {
      try {
        const response = await api.updateUser(id, userData)
        if (response.success) {
          // 重新获取用户列表
          await dispatch('fetchUsers')
          return response
        }
      } catch (error) {
        console.error('更新用户失败:', error)
        throw error
      }
    },
    // 异步删除用户
    async deleteUser ({ commit, dispatch }, id) {
      try {
        const response = await api.deleteUser(id)
        if (response.success) {
          // 重新获取用户列表
          await dispatch('fetchUsers')
          return response
        }
      } catch (error) {
        console.error('删除用户失败:', error)
        throw error
      }
    }
  }
})

